import { standInBody, type FeetPoint, type FrameMaskOf } from "daedalus-core";
import type { CoveringPiece, PropView } from "daedalus-renderer-phaser";
import { ODYSSEY_STAND_IN } from "odyssey-shared";

/**
 * The game page's cover report (ADR-071 decision 9), read-only and for dev pages: which pieces would cover a
 * character standing at a feet point, by the depth `character()` hands a sprite on that feet line and the
 * depths the page's prop views, presence views and things drew the world at. The editor's stand-in answers
 * the same question through the same core test (`coversStanding`), so a browser scenario can compare the
 * two pages piece by piece. Nothing here moves a character or reaches the server.
 */

/**
 * The pieces covering a character standing at a feet point.
 *
 * @param views Every prop view the page draws: its layers' props, its presence props and its things.
 * @param feet The feet point in whole world pixels.
 * @param depth The depth a character standing there draws at.
 * @param maskOf The solid pixels of a frame, by frame id.
 * @returns The covering pieces, each judged by its own frame.
 */
export function piecesCoveringCharacter(views: Iterable<PropView>, feet: FeetPoint, depth: number, maskOf: FrameMaskOf): CoveringPiece[] {
  const body = standInBody(feet, ODYSSEY_STAND_IN);
  return [...views].flatMap((view) => view.covering(body, depth, maskOf));
}
